var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fluid-sm leading-tight relative block max-w-lg px-6 py-2 mx-6 my-2 font-medium text-center cursor-pointer",class:[_vm.colorization],on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n  "+_vm._s(_vm.toast.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }